import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import { NAME, reducer } from './modules/Module';

const StudentsListLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'CurriculumStudents' */ './components/StudentsList'
		)
);

const PrintPagesLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'PrintPages' */ '@components/PrintPages/PrintPages'
		)
);

export default (store) => {
	store.injectReducer(NAME, reducer);
	return [
		{
			path: 'home/students',
			element: <AsyncLoading component={<StudentsListLazy />} />,
		},
		{
			path: 'home/students/print-pages',
			element: (
				<AsyncLoading
					component={<PrintPagesLazy permission="CanViewAdmissionSetup" />}
				/>
			),
		},
	];
};
